<template>
  <div class="createLike">
    <div
      class="liked2"
      @click="createFrontCollection"
      v-loading="loading"
      element-loading-background="rgba(232, 232, 232, 1)"
      v-if="bigSize"
    >
      <i class="my_icon praise1" v-show="!loading"></i>
      <p>{{counts.liked_counts}}</p>
    </div>
    <div
      class="liked"
      @click="createFrontCollection"
      v-loading="loading"
      element-loading-background="rgba(232, 232, 232, 1)"
      v-else
    >
      <i class="my_icon praise" v-show="!loading"></i>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false
    };
  },
  props: {
    opus_info: {}, //作品信息
    liked: {}, //是否被点赞的flag
    counts: {}, //作品点赞数
    bigSize: false //是否是大尺寸点赞按钮
  },
  methods: {
    // 收藏、点赞作品
    createFrontCollection() {
      if (this.opus_info.status !== "IdentityCertifieStatussuccess") {
        this.$message.warning("作品还未审核，无法点赞！");
        return;
      }
      this.loading = true;
      let obj = {
        type: "CollectionTypeLike",
        code: this.opus_info.code,
        user_id: this.opus_info.user_id,
        entity_type: this.opus_info.entity_type || "EntityTypeOpus"
      };
      this.api.createFrontCollection(obj, true).then(res => {
        if (res.error.err_code !== 0) {
          this.loading = false;
          return;
        }
        this.counts.liked_counts++;
        this.loading = false;
        this.liked.liked_flag = true;
        this.$message.success(`点赞作品成功！`);
      });
    }
  }
};
</script>
<style lang="scss">
.createLike {
  .el-loading-parent--relative {
    .el-loading-mask {
      border-radius: 50%;
      width: 50px;
      height: 50px;
    }
  }
  .liked2 {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    position: relative;
    text-align: center;
    cursor: pointer;
    background: rgba(17, 17, 17, 1);
    p {
      font-size: 12px;
      line-height: 24px;
      position: absolute;
      bottom: 13px;
      left: 50%;
      transform: translateX(-50%);
      color: #fff;
    }
    i {
      position: absolute;
      top: 23px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 20px;
    }
  }
  .liked2:hover {
    opacity: 0.8;
  }
  .el-loading-parent--relative.liked2 {
    .el-loading-mask {
      width: 80px;
      height: 80px;
    }
  }
}
</style>
